import React, { useRef, useState } from "react";

export const TryAgainVideo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [hasLoopedOnce, setHasLoopedOnce] = useState(false);

  const onEndedVideo = () => {
    if (hasLoopedOnce) {
      return;
    }

    setHasLoopedOnce(true);

    if (videoRef?.current) {
      try {
        videoRef.current.play().catch(() => null);
      } catch (e) {
        // noop
      }
    }
  };

  return (
    <video
      autoPlay
      muted
      onEnded={onEndedVideo}
      // playsInline attribute is specifically for iOS - see below link:
      // https://stackoverflow.com/questions/43570460/html5-video-autoplay-on-iphone/45402661#45402661
      playsInline
      ref={videoRef}
      src="/assets/img/try-again.mp4"
      style={{
        width: "300px",
        // The video shows black borders around the sides
        // https://stackoverflow.com/questions/20771971/video-player-shows-black-border
        clipPath: "inset(21px 1px)",
        margin: "auto",
      }}
    />
  );
};
